import MDButton from 'components/MDButton';
import React, { useState } from 'react';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices, useUploadImage } from 'hook/services';
import { useAgencyInfo } from 'context/agency';
import { Button, Stack } from '@mui/material';

const CreateModal = ({ handleRefresh }) => {
  const [agency] = useAgencyInfo();
  const uploadImage = useUploadImage()

  const AppService = useAppServices();
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [processing, setProcessing] = useState(false);

  const handleModal = () => setOpenAddProduct(true);
  const closeAddProduct = () => setOpenAddProduct(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);


    const payload = {
      name: e.target.name.value,

    };
    const { response } = await AppService.ToolCategory.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>

      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Tool Category
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>


            <MDBox display="flex" justifyContent="flex-end">
              <MDButton variant="gradient" color="primary" type="button" sx={{ mt: 2, mb: 1 }} onClick={closeAddProduct}>
                Close
              </MDButton>
              <MDButton variant="gradient" color="info" type="submit" sx={{ mt: 2, mb: 1, ml: 1 }} disabled={processing}>
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default CreateModal;
